import { useEffect } from 'react';

// Fades `[data-reveal]` content groups in as they scroll into view, once each,
// by adding `.is-revealed`. `[data-draw]` elements get the same class without
// the fade (e.g. peak outlines that only trace themselves in). One observer
// serves the whole page; styles live in index.css. Mount it once at the page
// level, after the sections it should watch.
export default function useScrollReveal() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll('[data-reveal], [data-draw]'));
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-revealed'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        });
      },
      // Trigger a little before the element's top edge clears the fold.
      { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
